(function($) {

	$(document).on( 'click', '.js-more-button', function( event ) {

		var $this = $( this );

		// get variables
		var query_vars = $this.data( 'query-args' );
		var page = parseInt( $this.data( 'page' ) );
		var append_posts_to_me = $this.data( 'where' );
		var template = $this.data( 'template' );

		// increment page number for next click
		$this.data( 'page', page + 1 );

		ajax_load_posts( query_vars, page, append_posts_to_me, template );
		// console.log( query_vars, page, append_posts_to_me );

	}); // On click

	function ajax_load_posts( query_vars, page, append_posts_to_me, template ) {

		var append_posts_to_me = $( append_posts_to_me );
		var more_button = $( '.js-more-button' );

		// when loading, make inactive
		more_button.addClass( 'is-inactive' ).removeClass( 'js-more-button' );

		// based on https://premium.wpmudev.org/blog/load-posts-ajax/
		$.ajax({
			url: ajaxvars.ajaxurl,
			type: 'post',
			data: {
				action: 'ajax_load_posts',
				query_vars: query_vars,
				page: page,
				template: template
			},
			success: function( html ) {
				// Add new posts
				// console.log( 'success', append_posts_to_me, html );
				if ( html ) {
					append_posts_to_me.append( html );

					if ( ! $( html ).hasClass( 'js-last-page' ) ) {
						more_button.removeClass( 'is-inactive' ).addClass( 'js-more-button' );
						// make button active again if new posts have been loaded and there is another page to load
					}
				}
			},
			error: function( html ) {
				console.log( 'error: ' + html );
			}
		});

	} // function

})(jQuery);